import type { SystemPackageVersionResourceListResponseApi } from '@ingenico/api-sdk-device-management-private';
import { enumVersionPublicationStatus } from '@ingenico/api-sdk-device-management-private';
import type { SearchFieldListResponseApi } from '@ingenico/api-sdk-device-management-private-v2';
import type { FieldConfiguration } from '@ingenico/react-ui/advanced-search';
import { isEqual, toString } from 'lodash-es';
import type { OverViewPayloadDTO } from '../../../components/overview-tab/Overviewtab.model';
import { VersionStatus } from '../../../pages/system-package-details-page/SystemPackageDetailsPage.model';
import type { SystemPackageVersionListResponseFront } from '../../models/applicationVersion.model';
import type { MappedSystemPackageVersionResourceListResponseV2Api } from '../../models/systemPackage.model';
import { toIsoStringIfDate } from '../utils/date.utils';

export function mapSystemPackageVersionResourceReadApi(
  response: SystemPackageVersionResourceListResponseApi,
): SystemPackageVersionListResponseFront {
  return {
    pagination: response.pagination,
    data: response.data.map((version) => ({
      applicationId: version.systemPackageId,
      id: version.id,
      versionNumber: version.versionNumber,
      longDescription: version.longDescription,
      shortDescription: version.shortDescription,
    })),
  };
}

export function mapSystemPackageVersionBySystemPackageIdOverview({
  data,
}: SystemPackageVersionResourceListResponseApi): Pick<
  OverViewPayloadDTO,
  'latestVersion' | 'latestVersionId' | 'markdown' | 'OSVersion' | 'publicationDate'
>[] {
  return data.map(({ longDescription, creationDate, versionNumber, id }) => {
    const computedCreationDate = toIsoStringIfDate(creationDate);
    return {
      latestVersionId: toString(id),
      markdown: toString(longDescription),
      publicationDate: computedCreationDate,
      latestVersion: toString(versionNumber),
    };
  });
}

export function mapSystemPackageVersionBySystemPackageIdVersion(
  response: SystemPackageVersionResourceListResponseApi,
): MappedSystemPackageVersionResourceListResponseV2Api {
  return {
    ...response,
    data: response.data.map((systemPackageVersion) => {
      const computedCreationDate = toIsoStringIfDate(systemPackageVersion?.creationDate);
      const computedStatus = isEqual(enumVersionPublicationStatus.PUBLISHED, systemPackageVersion.status)
        ? VersionStatus.PUBLISHED
        : VersionStatus.DEPRECATED;
      return {
        ...systemPackageVersion,
        version: toString(systemPackageVersion?.versionNumber),
        id: toString(systemPackageVersion?.id),
        creationDate: computedCreationDate,
        status: computedStatus,
      };
    }),
  };
}

export function mapSystemPackageVersionMinimalListToFieldConfiguration(
  response: SearchFieldListResponseApi,
): FieldConfiguration[] {
  return response.map(({ key, type }) => ({
    key,
    type,
    visible: true,
    searchable: true,
  })) as FieldConfiguration[];
}
